export type InsetShadows = ['none', string];

export const insetShadows: InsetShadows = [
  'none',
  'inset 2px 0px 4px 0px rgba(0,0,0,0.25), inset 0px 2px 4px 0px rgba(0,0,0,0.25)',
];
